<template>
  <div class="view">
    <div class="container">
      <router-view></router-view>
    </div>
  </div>
</template>

<script setup name='vuew'></script>

<style lang='scss' scoped>
.view{
  .container{
    // padding: 24px;
    // background: #fff;
    min-height: 360px;
  }
}
</style>